import React, {useEffect, useState } from "react";
import { getUser } from "../../auth";
import CreateStockForm from "../components/CreateStockForm";

const URL = process.env.REACT_APP_API_URL;

export default function CreateStock({ open, onClose }) {
  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [quantity, setQuantity] = useState(0);
  const [minStock, setMinStock] = useState(0);
  const [message, setMessage] = useState("");

  const user = getUser();

  useEffect(() => {
    if (!open) return;
    
    const fetchAvailableProducts = async () => {
      try {
        const res = await fetch(
          `${URL}/api/stock/available-products?empresa_id=${user.empresa_id}`
        );
        if (!res.ok) throw new Error("Error fetching available products");
        const data = await res.json();
        setAvailableProducts(data);
      } catch (error) {
        console.error("Error fetching available products:", error);
        setMessage("Error al obtener los productos disponibles.");
      }
    };

    fetchAvailableProducts();
  }, [open, user?.empresa_id]);

  const handleReset = () => {
    setSelectedProduct(null);
    setQuantity(0);
    setMinStock(0);
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedProduct) {
      setMessage("Debe seleccionar un producto.");
      return;
    }

    try {
      const response = await fetch(`${URL}/api/stock/`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "X-Empresa-Id": user.empresa_id,
        },
        body: JSON.stringify({
          product_id: selectedProduct.id,
          quantity: Number(quantity),
          min_stock: Number(minStock),
        }),
      });

      if (response.ok) {
        setMessage("Stock creado exitosamente.");
        handleReset();
        onClose();
      } else {
        const errorData = await response.json();
        setMessage(`Error al crear el stock: ${errorData.detail}`);
      }
    } catch (error) {
      console.error("Error al crear el stock:", error);
      setMessage("Error al crear el stock. Inténtalo de nuevo.");
    }
  };

  return (
    <CreateStockForm
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      onReset={handleReset}
      availableProducts={availableProducts}
      selectedProduct={selectedProduct}
      setSelectedProduct={setSelectedProduct}
      quantity={quantity}
      setQuantity={setQuantity}
      minStock={minStock}
      setMinStock={setMinStock}
      message={message}
    />
  )
}